module.exports = __webpack_public_path__ + "static/media/1. To start.e0d21377.svg";